import { render, staticRenderFns } from "./PlusRoundedSolidIcon.vue?vue&type=template&id=553b8957&scoped=true"
import script from "./PlusRoundedSolidIcon.vue?vue&type=script&lang=js"
export * from "./PlusRoundedSolidIcon.vue?vue&type=script&lang=js"
import style0 from "./PlusRoundedSolidIcon.vue?vue&type=style&index=0&id=553b8957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b8957",
  null
  
)

export default component.exports